import * as API from '@/api';
import DEFINES from '@/defines';
import router from '../../router';
import {getField, updateField} from 'vuex-map-fields';

//initial state
function initialState () {
  return {
    plan: null,
  };
}
const state = initialState ();

// actions
const actions = {
  async getPlans (context, payload) {
    var response = await API.plan.getPlans (payload);
    context.commit ('set_plans', {
      plans: response.plans,
    });
    return response;
  },

  async createPlan (context, payload) {
    var response = await API.plan.createPlan (payload);
    return response;
  },

  async updatePlan (context, payload) {
    var response = await API.plan.updatePlan (payload);
    return response;
  },
};

//getters
const getters = {
  getPlans: state => {
    return state.plans;
  },
};

// mutations
const mutations = {
  set_plans (state, payload) {
    state.plans = payload.plans;
  },
  reset (state) {
    // acquire initial state
    const s = initialState ();
    Object.keys (s).forEach (key => {
      state[key] = s[key];
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
